export enum EnumDetailIconNames {
  Autos = 'car',
  ingenieros = 'engineers',
  Generico = 'generic',
}

export enum EnumCarDetailProperties {
  Direccion = 'Dirección',
  EstadoActualizacion = 'Estado_de_Actualización',
  EstadoVehiculo = 'Estado_del_Vehiculo',
  UltimaActualizacion = 'Última_Actualización',
  Coordenadas = 'Coordenadas',
  Bloqueo = 'Bloqueo',
  Subcuenta = 'Subcuenta',
  Odometro = 'Odómetro',
  Alias = 'Alias',
  Valor_unico = 'Valor',
}

export enum EnumEngineerDetailProperties {
  Direccion = 'Dirección',
  EstadoActualizacion = 'Estado_de_Actualización',
  UltimaActualizacion = 'Última_Actualización',
  Coordenadas = 'Coordenadas',
  Subcuenta = 'Subcuenta',
  Valor_unico = 'Valor',
}

export enum EnumGenericDetailProperties {
  Direccion = 'Dirección',
  EstadoActualizacion = 'Estado_de_Actualización',
  EstadoVehiculo = 'Estado_del_Vehiculo',
  UltimaActualizacion = 'Última_Actualización',
  Coordenadas = 'Coordenadas',
  Bloqueo = 'Bloqueo',
  Subcuenta = 'Subcuenta',
  Odometro = 'Odómetro',
  Alias = 'Alias',
  Valor_unico = 'Valor',
}
